/**
 * @generated SignedSource<<3b5415c1145aced7da35d540b217f96f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RefundStatus = "ApplyComplete" | "ApplyImpossible" | "ApplyPossible" | "Complete" | "Impossible" | "None" | "Possible" | "RefundFinish" | "RefundImpossible" | "Retry";
import { FragmentRefs } from "relay-runtime";
export type RetryBanner$data = {
  readonly bznavRefund: {
    readonly imputedYear: {
      readonly corps: string;
      readonly indis: string;
    };
    readonly user: {
      readonly corps: ReadonlyArray<{
        readonly refundStatus: RefundStatus;
      }> | null | undefined;
      readonly indis: ReadonlyArray<{
        readonly refundStatus: RefundStatus;
      }> | null | undefined;
      readonly tritxIndis: ReadonlyArray<{
        readonly refundStatus: RefundStatus;
      }> | null | undefined;
    };
  };
  readonly " $fragmentType": "RetryBanner";
};
export type RetryBanner$key = {
  readonly " $data"?: RetryBanner$data;
  readonly " $fragmentSpreads": FragmentRefs<"RetryBanner">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "refundStatus",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RetryBanner",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BznavRefundOutput",
      "kind": "LinkedField",
      "name": "bznavRefund",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RefundUserType",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RefundHistoryType",
              "kind": "LinkedField",
              "name": "indis",
              "plural": true,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RefundHistoryType",
              "kind": "LinkedField",
              "name": "corps",
              "plural": true,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RefundHistoryType",
              "kind": "LinkedField",
              "name": "tritxIndis",
              "plural": true,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ImputedYearOutput",
          "kind": "LinkedField",
          "name": "imputedYear",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "indis",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "corps",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "7c27ad3e4e560ad3a4d3436422dd6a5d";

export default node;
